import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=373a5fe6&scoped=true&"
import script from "./testPaper.vue?vue&type=script&lang=js&"
export * from "./testPaper.vue?vue&type=script&lang=js&"
import style0 from "./testPaper.vue?vue&type=style&index=0&id=373a5fe6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a5fe6",
  null
  
)

export default component.exports